import { createAction } from '@reduxjs/toolkit';

import { AppConfig } from '../../config/configureApp';


export const setConfig = createAction<AppConfig>('config/setConfig');
